import { render } from "./SidebarProvider.vue?vue&type=template&id=ed5889d8&ts=true"
import script from "./SidebarProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarProvider.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarProvider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed5889d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed5889d8', __exports__)) {
    api.reload('ed5889d8', __exports__)
  }
  
  module.hot.accept("./SidebarProvider.vue?vue&type=template&id=ed5889d8&ts=true", () => {
    api.rerender('ed5889d8', render)
  })

}


export default __exports__